import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../../axios/axios'; // make sure this path is correct
import { toast } from "react-toastify";

const TokenHandler = ({ setCompLoad, setAuthData }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    if (token) {
      setCompLoad?.(true);
      axios
        .get(`auto-login?token=${token}`)
        .then((data) => {
          const respCode = data?.data?.resp_code;
          const token = data?.data?.data?.token;
          localStorage.setItem("agentId", data?.data?.data?.id);
          localStorage.setItem("agentModuleToken", token);
          if (respCode === 200) {
            setAuthData(data?.data?.data);
            navigate("/");
          }
        })
        .catch((err) => {
          console.error('Auto-login failed:', err);
          toast.error("Invalid Credentials");
        })
        .finally(() => {
          setCompLoad?.(false);
        });
    }
  }, [location.search]);

  return null;
};

export default TokenHandler;
